
// import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import RenderHome from './components/Pages/AForluz/Home/RenderHome';

try {
  const { REACT_APP_GOOGLE_GA_TAG } = process.env;

  const metaTag = document.createElement('meta');
  metaTag.name = 'custom-variable';
  metaTag.content = REACT_APP_GOOGLE_GA_TAG ?? 'G-R0BM8HM4F8';
  document.head.appendChild(metaTag);
} catch (error) {
  console.log('✌️ error --->', error);
}

ReactDOM.render(
  <App />,
  document.getElementById('root'),
  () => {
    // Remove banner SSR após hidratação
    document.documentElement.classList.add('react-hydrated');
    const ssrBanner = document.getElementById('critical-banner-ssr');
    if (ssrBanner) {
      setTimeout(() => ssrBanner.remove(), 100);
    }
  }
); 
